import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProtectionDashboardFactFindService {
  public reload$ = new Subject();
}
